export default __webpack_public_path__ + "static/media/i009vp.63d7803c.webp";